import React from 'react';
import PropTypes from 'prop-types';

export default class MountAfterDelay extends React.Component {
  state = {
    ready: false,
  };

  componentDidMount() {
    this.timeoutId = setTimeout(() => this.setReady(), this.props.timeout);
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  setReady() {
    this.timeoutId = null;
    this.setState({
      ready: true,
    });
  }

  render() {
    if (this.props.render) {
      return this.props.render(this.state.ready);
    }
    if (this.state.ready) {
      return this.props.children;
    }
    return this.props.placeholder || null;
  }
}

MountAfterDelay.propTypes = {
  timeout: PropTypes.number.isRequired,
};
